<template>
  <div class="content-container padded-content-container">
    <div class="content-container-content"><slot /></div>
  </div>
</template>

<script>
export default {
  name: "InfoContentContainer"
};
</script>

<style lang="scss" scoped>
.content-container {
  background-color: white;
  margin: 3rem 0;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.padded-content-container {
  padding: 0 $padded-content-container-padding $padded-content-container-padding
    $padded-content-container-padding;

  .content-container-content {
    padding: 0 $padded-content-container-padding;
  }
}
</style>
